var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"binds-card-actions",class:`binds-alignment-${_vm.bindsAlignment}`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }